import React from 'react'
import { motion, MotionProps } from 'framer-motion';

//styles
import "./Faq.css"

import { GiArrowhead, GiCauldron, GiGriffinShield, GiPalette } from "react-icons/gi";
import { Faq as FaqModel } from '../../Models/Faq';
import FaqItem from '../FaqItem/FaqItem';

import { 
  LuStore, 
  LuHandshake, 
  LuBoxes, 
  LuTruck, 
  LuShieldCheck 
} from "react-icons/lu";

const Faq = () => {

    const getFadeUpAnimatioBottom = (): MotionProps => ({
      initial: { opacity: 1, y: 100 },
      whileInView: { opacity: 1, y: 0 },
      viewport: { once: true, margin: "0px" },
      transition: {
          duration: 0.5,
          ease: "easeOut",
          delay: 0.3,
      },
      });

  const faq:FaqModel[]=[
    {
      id:1,
      question:"¿Dónde puedo comprar sus productos?",
      icon:<LuStore size={20} />,
      answer:"Actualmente, Frikistore Venezuela es nuestro distribuidor oficial autorizado. Puedes gestionar la compra de todo nuestro catálogo directamente a través de sus canales de atención."
    },
    {
      id:2,
      question:"¿Puedo ser distribuidor o vender sus productos?",
      icon:<LuHandshake size={20} />,
      answer:"¡Sí! Próximamente abriremos nuestro programa de alianzas para tiendas y distribuidores. Si te interesa comercializar Card Armory, contáctanos para registrar tus datos."
    },
    {
      id:3,
      question:"¿Los productos de la galería son los únicos disponibles?",
      icon:<LuBoxes size={20} />,
      answer:"Actualmente mostramos nuestro stock disponible, pero muy pronto incorporaremos nuevos lanzamientos al catálogo, incluyendo binders para toploaders, sleeves de alta resistencia y más."
    },
    {
      id:4,
      question:"¿Los materiales son totalmente seguros para mis cartas?",
      icon:<LuShieldCheck size={20} />,
      answer:"Absolutamente. Todos nuestros accesorios están fabricados con materiales de nivel archivo, 100% libres de ácido y sin PVC, diseñados para proteger el valor de tu colección a largo plazo."
    }

  ]

  return (
    <div className='faq-section'>

    <div className="custom-shape-divider-bottom-1788470680" >
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
            <path d="M1200 120L0 16.48 0 0 1200 0 1200 120z" className="shape-fill"></path>
        </svg>
    </div>

      <h2>Preguntas frecuentes</h2>

      <div className='faq-section-list'>
        {faq.map((f:FaqModel, index)=>{
          return <FaqItem faq={f} key={"faq"+ f.id} delay={index+1} />
        })}
      
      </div>

    </div>
  )
}

export default Faq